import {
  CarouselNavButtonLeft,
  CarouselNavButtonRight,
} from '@components/MiscComponents/GridAndCarouselComponents/index';
import { useMediaQuery } from '@util/mediaQuery/index';
import { ReactNode, useEffect, useRef, useState } from 'react';
import SwiperCore, { A11y, Navigation } from 'swiper';
import { CarouselSwiper, CarouselSwiperSlide, StyledCarouselNavButtonWrapper } from './style';

export interface CardGridWithMobileCarouselProps {
  cardArr: ReactNode[];
  cardType?: 'shop' | 'article' | 'advisor' | 'development' | 'pressRelease' | 'media' | 'property'; //used for custom styling right now
  dataTestId?: string;
}

const CardGridWithMobileCarousel = ({
  cardArr,
  cardType,
  dataTestId,
}: CardGridWithMobileCarouselProps): ReactNode => {
  let pageIsBiggerThanMobile = useMediaQuery('(min-width: 580px)');

  //make references for swiper navigation buttons
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [swiper, setSwiper] = useState<SwiperCore>(null);

  // generate a unique class name for the Swiper container
  const swiperContainerClass = `swiper-container-${Math.floor(Math.random() * 100000)}`;

  // if pageIsBiggerThanMobile is true, then we want to destroy the swiper instance
  // but if it's false, we want to create a new one
  useEffect(() => {
    if (swiper) {
      if (pageIsBiggerThanMobile) {
        swiper.destroy(true, true);
      } else {
        setSwiper(
          new SwiperCore(`.${swiperContainerClass}`, {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            },
            a11y: {
              prevSlideMessage: 'Previous slide',
              nextSlideMessage: 'Next slide',
            },
          }),
        );
      }
    }
  }, [pageIsBiggerThanMobile]);

  SwiperCore.use([Navigation, A11y]);

  return (
    <>
      <CarouselSwiper
        className={swiperContainerClass}
        data-testid={`${dataTestId ? dataTestId + '-' : ''}swiper-container`}
        spaceBetween={0}
        slidesPerView={1}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onSwiper={setSwiper}
      >
        {cardArr &&
          cardArr.map((card, index) => {
            return (
              <CarouselSwiperSlide
                data-testid={`${dataTestId ? dataTestId + '-' : ''}card-${index}`}
                key={index}
              >
                {card}
              </CarouselSwiperSlide>
            );
          })}
      </CarouselSwiper>

      <StyledCarouselNavButtonWrapper $cardType={cardType}>
        <CarouselNavButtonLeft ref={prevRef} />
        <CarouselNavButtonRight ref={nextRef} />
      </StyledCarouselNavButtonWrapper>
    </>
  );
};

export default CardGridWithMobileCarousel;
